export const DiamondPurple = ({
  height = 10,
  width = 11,
}: {
  height?: number;
  width?: number;
}) => (
  <svg
    width={width!}
    height={height!}
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.3527 3.75L5.8002 10L4.2477 3.75H7.3527ZM5.37229 0L4.31187 2.91667H7.28854L6.22812 0H5.37229ZM8.17521 2.91667H10.734C10.6955 2.79779 10.6393 2.68541 10.5673 2.58333L9.09604 0.52375C8.98043 0.3618 8.82783 0.229788 8.65093 0.138692C8.47403 0.0475957 8.27793 4.71403e-05 8.07895 0L7.11479 0L8.17521 2.91667ZM8.21062 3.75L7.05854 8.45833L10.5331 4.08333C10.6112 3.98239 10.6732 3.86994 10.7169 3.75H8.21062ZM3.38979 3.75H0.883538C0.927892 3.86996 0.990428 3.98238 1.06896 4.08333L4.54187 8.45833L3.38979 3.75ZM3.42521 2.91667L4.48562 0H3.52146C3.32248 4.71403e-05 3.12638 0.0475957 2.94948 0.138692C2.77258 0.229788 2.61998 0.3618 2.50437 0.52375L1.03312 2.58333C0.960925 2.68531 0.904721 2.79772 0.866455 2.91667H3.42521Z"
      fill="url(#paint0_linear_5337_13663)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5337_13663"
        x1="0.866455"
        y1="5"
        x2="10.734"
        y2="5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8B08FD" />
        <stop offset="1" stop-color="#5622FF" />
      </linearGradient>
    </defs>
  </svg>
);
